
import './Navbar.css'
import {
  NavBtn,
  NavBtnLink,
} from './NavbarElements';
import React , {useState} from 'react';
import Logo from '../../assets/jpg/WizWackLogo.png';
import {Navbar, NavItem, Collapse, NavbarToggler, Nav} from "reactstrap";
import { NavLink } from 'react-router-dom';

const Navbar2 = (props) => {

    const [isNavOpen, setNav] = useState(false);
    function toggleNav() {
        setNav(!isNavOpen);
    }

    return (
      <div>
          <Navbar   style={{backgroundColor: "black"}} className="navbar-expand-md navbar fixed-top text-white" >
           <img className="img img-fluid wizLogo" src = {Logo} alt = "LOGO"  />
                <NavbarToggler className="text-white navbar-dark"  color="white" onClick={toggleNav} />

                <Collapse className="ms-auto"  isOpen={isNavOpen} navbar>
                <Nav  className="navText align-items-center ml-auto mr-5" navbar>
              <NavItem className="mr-5" >
                <NavLink style={{color: 'white', textDecoration: 'none'}} className="nav-link mr-5  " to="/services"  onClick = {props.onHomeClick} >
                  Home
                </NavLink>
              </NavItem>
              <NavItem className="mr-5">
                <NavLink style={{color: 'white', textDecoration: 'none'}} className="nav-link mr-5 " to="/services"  onClick = {props.onServiceClick} >
                  Services
                </NavLink>
              </NavItem>
              <NavItem className="mr-5">
                <NavLink style={{color: 'white', textDecoration: 'none'}} className="nav-link mr-5 " to="/services"  onClick = {props.onTestimonialClick} >
                Testimonials
                </NavLink>
              </NavItem>
              <NavItem className="mr-5">
                <NavLink style={{color: 'white', textDecoration: 'none'}} className="nav-link mr-5 " to="/services"  onClick = {props.onAboutClick} >
                About Us
                </NavLink>
              </NavItem>
              <NavItem className="mr-5">
              <NavBtn  className="ml-5 " >
                <NavBtnLink  className="text-center" to='/services' onClick = {props.onContactClick}>Contact Us</NavBtnLink>
                </NavBtn>
              </NavItem>
            </Nav>
                </Collapse>
              
          </Navbar>
          </div>
    );
}

  
export default Navbar2;